module.exports = __webpack_public_path__ + "static/media/publico_alvo.21e1aa9d.jpg";